export default "__VITE_ASSET__CuSlGikM__"